<template>
    <div>
        <!-- banner -->
        <div class="banner_top_big">
            <headerNew></headerNew>
            <div class="top_box">
                <div class="banner_box">
                    <el-carousel :autoplay-speed="4000" :interval="4000" trigger="click" autoplay>
                        <el-carousel-item>
                            <div class="first_banner">
                                <div class="first_width">
                                    <div class="first_left">
                                        <div>
                                            <p class="banner_po">让版权实现更大价值</p>
                                            <p class="banner_pt">开通会员，尊享一站式版权服务</p>
                                            <p class="banner_pr">存证  /  登记  /  取证  /  监测  /  版权区块链</p>
<!--                                            <a class="banner_btn" @click="goXu" v-if="vipFlag && vipFlag == 1">VIP续费</a>-->
<!--                                            <a class="banner_btn" @click="openVip" v-else>开通VIP</a>-->
                                            <a class="banner_btn" @click="openActivity">邀好友 双赢好礼</a>
                                        </div>
                                        <img src="../../images/fireCNew.png"/>
                                    </div>
                                    <img src="../../images/indexBanner.png" alt='版权登记' style="width:100%;" class="dabanner"/>
                                    <!--<a href="https://svip.bqj.cn" target="_blank">
                                        <img src="../../images/indexBanner.jpg" alt='版权登记' style="width:100%;" class="dabanner"/>
                                    </a>-->
                                    <!-- <img src="../../images/newBanner.png" alt='版权登记' style="width:100%;" class="dabanner"/> -->
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <!-- banner下的确权框 -->
            <div class="banner_btm_box">
                <div class="banner_btm_flex">
                    <p class="banner_btm_flex_tit">
                        <img src='../../images/bqIcon.png'/>
                        <span>版权确权</span>
                    </p>
                    <ul>
                        <li>
                            <p class="list_tit">版权存证</p>
                            <p class="list_txt"><span @click="lijiCz">版权存证（版权区块链存证）</span></p>
                        </li>
                        <li>
                            <p class="list_tit">版权登记</p>
                            <p class="list_txt">
                                <span @click="lijiDci">美术作品登记</span>|
                                <span @click="lijiDci"  style="margin-left:14px">文字作品登记</span>|
                                <span @click="lijiDci"  style="margin-left:14px">音乐作品登记</span><br>
                                <span @click="lijiDci"> 电影作品登记</span>|
                                <span @click="lijiDci"  style="margin-left:14px">作品登记加急</span>
                            </p>
                        </li>
                        <li>
                            <p class="list_tit">软件著作权登记</p>
                            <!-- <p class="list_txt">
                                <span @click="openChats">网站</span>|
                                <span @click="openChats" style="margin-left:14px">电脑软件</span>|
                                <span @click="openChats" style="margin-left:14px">APP</span>|
                                <span @click="openChats" style="margin-left:14px">源代码</span>
                            </p> -->
                            <p class="list_txt" @click="goCopyrightMessage">
                                <span>网站</span>|
                                <span style="margin-left:14px">电脑软件</span>|
                                <span style="margin-left:14px">APP</span>|
                                <span style="margin-left:14px">源代码</span>
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="banner_btm_flex">
                    <p class="banner_btm_flex_tit">
                        <img src='../../images/wqIcon.png'/>
                        <span>版权维权</span>
                    </p>
                    <ul>
                        <li>
                            <p class="list_tit">版权监测</p>
                            <p class="list_txt">
                                <span @click="goMonitor">图片监测</span>|
                                <span style="margin-left:14px" @click="goMonitor">文字监测</span>|
                                <span style="margin-left:14px" @click="goMonitor">音乐监测</span>|
<!--                                <span style="margin-left:14px" @click="goMonitor">电商监测</span><br/>-->
                                <span @click="goMonitor">公众号监测</span>
                            </p>
                        </li>
                        <li>
                            <p class="list_tit">法律服务</p>
                            <p class="list_txt"><span @click="zixunLs">免费问律师</span></p>
                        </li>
                    </ul>
                </div>
                <div class="banner_btm_flex">
                    <p class="banner_btm_flex_tit">
                        <img src='../../images/qqIcon.png'/>
                        <span>侵权取证</span>
                    </p>
                    <ul>
                        <li>
                            <p class="list_tit">电脑端取证</p>
                            <p class="list_txt">
                                <span @click="evidenceWeb">网页取证</span>|
                                <span @click="gcquzheng" style="margin-left:14px">过程录屏取证</span>
                            </p>
                        </li>
                        <li>
                            <p class="list_tit">手机端取证</p>
                            <p class="list_txt">
                                <span @click="downLoadQzb">录音取证</span>|
                                <span @click="downLoadQzb" style="margin-left:14px">拍照取证</span>|
                                <span @click="downLoadQzb" style="margin-left:14px">录像取证</span>|
                                <span @click="downLoadQzb" style="margin-left:14px">录屏取证</span>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!--取证宝下载弹框-->
        <Modal v-model="downLoad" width="1200" :mask-closable="false" footer-hide class="model_qzb_box">
           <div class="model_box">
               <div class="model_box_left"><img src="../../images/hezuohuoban/qzb_sj.png"/></div>
               <div class="model_box_right">
                   <div class="right_top">
                       <img src="../../images/hezuohuoban/qzb_logo.png"/>
                       <ul>
                           <li>取证宝APP</li>
                           <li>取证宝APP支持拍照、录像、录音、手机录屏等取证功能，证据受司法认可，真实有效</li>
                       </ul>
                   </div>
                   <div class="right_btm">
                       <div class="right_btm_left"><img src="../../images/hezuohuoban/qzb_ewm.png"/></div>
                       <ul class="right_btm_right">
                           <li class="btm_load" style="margin:15px 0 24px;" @click="iosLoad">
                               <img src='../../images/hezuohuoban/qzb_pg.png'/>
                               <span style="cursor: pointer;">iPhone下载</span>
                           </li>
                           <li class="btm_load" @click="androidLoad">
                               <img src='../../images/hezuohuoban/qzb_anz.png'/>
                               <span style="cursor: pointer;">Android下载</span>
                           </li>
                           <li class="btm_txt">*打开手机扫一扫左侧二维码即可下载APP</li>
                       </ul>
                   </div>
               </div>
           </div>
        </Modal>
    </div>
</template>

<script>
    import headerNew from '@/views/main-components/opcatHeader';
    import Cookies from "js-cookie";
 import {_getDictList} from '@/api/staticPage';
    export default {
        metaInfo: {
            title: '版权登记|版权保护-版权服务专家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权登记,版权保护,版权登记查询,版权保护中心,版权保护服务,版权登记服务,版权家'
            },{
                name: 'Description',
                content: '版权家是专业提供版权登记查询，版权保护申请；我们作为版权保护服务专家，为版权人提供极致的版权登记咨询、版权交易、版权监测、版权维权等服务体验。'
            }]
        },
        name:'indexone',
        props: {
            refresh: {
                type: Number,
                default: 0
            }
        },
        components:{
            headerNew
        },
        data(){
            return {
               vipFlag: 0, //VIP类型 0未开通 1vip会员  2体验会员
               downLoad:false,
            }
        },
        watch: {
            refresh: {
                immediate: true,
                handler: function () {
                    console.log('更新banner')
                    this.isOpenVip()
                }
            }
        },
        mounted(){
            // this.isOpenVip();
        },
        methods:{
            //打开美洽聊天
			openChats() {
				if (this.meiqia_state) {
					_MEIQIA('showPanel');
				} else {

					console.log("美洽开始初始化" + new Date().getTime());
					(function(m, ei, q, i, a, j, s) {
						m[i] = m[i] || function() {
							(m[i].a = m[i].a || []).push(arguments)
						};
						j = ei.createElement(q),
							s = ei.getElementsByTagName(q)[0];
						j.async = false;
						j.charset = 'UTF-8';
						j.src = '//static.meiqia.com/dist/meiqia.js';
						s.parentNode.insertBefore(j, s);
					})(window, document, 'script', '_MEIQIA');

					_MEIQIA('manualInit');
					_MEIQIA('entId', '6351b02e1b6975b5b7bb282762244a9f');
					//隐藏美洽客服按钮
					_MEIQIA('withoutBtn');
					// 初始化成功时的回调
					_MEIQIA('allSet', this.meiqiaCallBack);
					//创建美洽
					_MEIQIA('init');
					console.log("美洽初始化结束" + new Date().getTime());
					_MEIQIA('showPanel');
				}
			},
            //美洽初始化成功回调
			meiqiaCallBack() {
				console.log("初始化回调成功" + new Date().getTime());
				this.meiqia_state = true;
			},
            isOpenVip(){
                let userInfo = Cookies.get("userInfo");
                if (userInfo && userInfo != '') {
                    userInfo = JSON.parse(userInfo);
                    let vipFlag = userInfo.vipFlag;
                    this.vipFlag = vipFlag
                } else {
                    this.vipFlag = 0
                }
                console.log(this.vipFlag)
            },
            goMonitor(){
                window.open('/monitor', '_blank')
            },
            zixunLs(){
                window.open('/fuwu/dianhua.html', '_blank')
            },
            evidenceWeb(){
                window.open('/evidenceWeb', '_blank')
            },
            gcquzheng(){
                window.open('https://quzhengbao.bqj.cn/firstpage.html', '_blank')
            },
            downLoadQzb(){
                this.downLoad = true
            },
            goXu(){
                let userInfo = Cookies.get("userInfo");
                if (userInfo && userInfo != '') {
                    userInfo = JSON.parse(userInfo);
                    this.$router.push({
                        name: "openVip",
                        query:{
                            type:userInfo.medalName
                        },
                    });
                }else{
                    toast('请登录后再操作')
                    return false;
                }
            },
            openVip(){
                // this.$router.push({path: '/huiyuan.html'})
                window.open('/huiyuan.html', '_blank')
            },
            openActivity(){
              // this.$router.push({path: '/huiyuan.html'})
              window.open('https://static.bqj.cn/animation/activity.html', '_blank')
            },
            lijiCz(){
                window.open('/apply-cert', '_blank')
            },
            lijiDci(){
                window.open('/copyrightRegistration', '_blank')
            },
            goCopyrightMessage(){
                window.open('/copyright-message', '_blank')
            },
            iosLoad(){
                window.open("https://apps.apple.com/cn/app/%E5%8F%96%E8%AF%81%E5%AE%9D/id1184801162?mt=8",'_blank')
            },
            androidLoad(){
                let data = {type: 'qzb_android_link'};
                _getDictList(data).then(res => {
                    if (res.code == 200) {
                        window.open(res.result[0].value)
                    }
                })
            },
        }

    }
</script>

<style scoped lang="less">
/*//下载取证宝app*/
    .model_qzb_box {
        /deep/ .ivu-modal-body{
            padding:0;
        }
    }
    .model_box{
        display: flex;
        .model_box_left{
            width: 506px;
            height: 577px;
            background: #F9F9F9;
            border-radius: 15px 0px 0px 15px;
            img{
                width: 394px;
                height: 564px;
                display: block;
                margin: 6px 56px;
            }
        }
        .model_box_right{
            flex:1;
            padding:96px 70px 0 95px;
            box-sizing: border-box;
            .right_top{
                display: flex;
                margin-bottom:84px;
                &>img{
                    width: 106px;
                    height:106px;
                    margin-right:28px;
                }
                ul{
                    flex: 1;
                    li:nth-of-type(1){
                        font-size: 24px;
                        font-weight: 800;
                        font-family:SourceHanSansCN;
                        color: #333333;
                        line-height: 36px;
                    }
                    li:nth-of-type(2){
                        font-size: 14px;
                        color: #999999;
                        line-height: 28px;
                    }
                }
            }
            .right_btm{
                display: flex;
                .right_btm_left{
                    width: 201px;
                    height: 201px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.12);
                    border-radius: 8px;
                    margin-right:60px;
                    img{
                        width: 186px;
                        height:186px;
                        display: block;
                        margin: 8px 7px 7px 8px;
                    }
                }
                .right_btm_right{
                    flex: 1;
                    .btm_load{
                        width: 201px;
                        height: 52px;
                        background: #333333;
                        border-radius: 12px;
                        font-size: 16px;
                        color: #FFFFFF;
                        line-height: 52px;
                        display:flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            width: 30px;
                            height: 30px;
                            display: inline-block;
                            margin-right:14px;
                        }
                    }
                    li:last-child{
                        font-size: 14px;
                        color: #999999;
                        line-height: 28px;
                        margin-top: 23px;
                    }
                }
            }
        }
    }


.banner_top_big{
    height: 910px;
    position: relative;
    /deep/.el-carousel__indicators{
        display:none;
    }
    /deep/.el-carousel__arrow{
        display: none !important;
    }
}
.dabanner{
        height: 696px;
    }
.top_box{
    position: relative;
    width: 100%;
    /deep/ .el-carousel{
        height:696px;
    }
    /deep/ .el-carousel__container{
        height: 696px;
    }
    /deep/ .first_width{
        position: relative;
    }

    /deep/ .el-carousel__indicators{
        width: 1200px;
        height: 10px;
        top: 0;
        text-align: right;
        margin: auto;
        bottom: 0;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        top:370px;
    }
}
    //banner
    .banner_box{
        .first_banner{
            .first_width{
                position: relative;
                .first_left{
                    position: absolute;
                    width: 1200px;
                    left: 50%;
                    margin-left: -600px;
                    display: flex;
                    &>div{
                        flex: 1;
                    }
                    &>img{
                        display: block;
                        width: 466px;
                        height: 435px;
                        margin-top: 117px;
                    }
                    .banner_po{
                        font-size: 54px;
                        font-weight: 800;
                        color: #FFFFFF;
                        line-height: 80px;
                        margin-top:182px;
                        font-family:SourceHanSansCN;
                    }
                    .banner_pt{
                        font-size: 22px;
                        font-weight: 500;
                        font-family:SourceHanSansCN;
                        color: #FFFFFF;
                        line-height: 23px;
                        margin: 48px 0 22px;
                    }
                    .banner_pr{
                        font-size: 16px;
                        color: #FFFFFF;
                        line-height: 22px;
                        margin-bottom: 58px;
                    }
                    .banner_btn{
                        width: 154px;
                        height: 40px;
                        background: #FBDA5D;
                        border-radius: 20px;
                        font-size: 14px;
                        font-weight: bold;
                        color: #333333;
                        line-height:40px;
                        text-align: center;
                        letter-spacing: 1px;
                        display: block;
                        font-family:SourceHanSansCN;
                        &:hover{
                            box-shadow: 0px 4px 8px 0px rgba(255, 216, 0, 0.6);
                        }
                    }
                }
            }
        }
    }
    //2
    .banner_btm_box{
        width: 1201px;
        background: #FFFFFF;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
        position: relative;
        margin: -120px auto auto auto;
        z-index: 2;
        border-radius:20px;
        display: flex;
        padding: 32px 0;
        box-sizing: border-box;
        .banner_btm_flex{
            flex: 1;
            border-right:1px solid #EFEFEF;
            padding:0 0px 0 46px;
            box-sizing: border-box;
            .banner_btm_flex_tit{
                font-size: 24px;
                font-weight: bold;
                font-family:SourceHanSansCN;
                color: #000000;
                line-height: 36px;
                vertical-align: middle;
                text-align: center;
                margin-left:-46px;
                img{
                    width: 32px;
                    height: 32px;
                    display: inline-block;
                    margin-right: 3px;
                    vertical-align: middle;
                }
                span{
                    vertical-align: middle;
                }
            }
            .list_tit{
                font-size: 16px;
                font-weight: 700;
                font-family:SourceHanSansCN;
                color: #333333;
                line-height: 24px;
                margin: 22px 0 6px;
            }
            .list_txt{
                font-size: 12px;
                color: #444444;
                line-height: 24px;
                span{
                    display: inline-block;
                    margin-right: 14px;
                    cursor: pointer;
                    &:hover{
                        color: #F9C300;
                    }
                }
            }
        }
        .banner_btm_flex:last-child{
            border: none;
        }
        ul{
            li{
                list-style: none;
            }
        }
    }
</style>
